import React, { useEffect, useMemo, useState } from 'react';
import { Card, Select, Space, Typography } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import QaqcPipeWorkareaCreate from './QaqcPipeWorkareaCreate';
import type { QaqcPipeWorkarea } from '../../../../types';
import { fetchSqlData } from '../../../../services/api';
import { useGetQaqcPipeWorkarea } from '../../../../hooks/genericHooks';

const QaqcPipeWorkareaView: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: { record?: QaqcPipeWorkarea } };
  const params = useParams();
  const [record, setRecord] = useState<QaqcPipeWorkarea | undefined>(state?.record);
  const { data: listResp } = useGetQaqcPipeWorkarea();

  useEffect(() => {
    const load = async () => {
      if (record) return;
      const id = params.id ? Number(params.id) : NaN;
      if (!Number.isFinite(id)) return;
      try {
        const res = await fetchSqlData('qaqc_pipe_workarea', 'id', id);
        const row = Array.isArray(res?.data) ? res.data[0] : (Array.isArray(res) ? res[0] : undefined);
        if (row) setRecord(row as QaqcPipeWorkarea);
      } catch {}
    };
    load();
  }, [params.id]);

  const goBack = () => navigate(-1);

  const options = useMemo(() => {
    const rows: QaqcPipeWorkarea[] = (listResp?.data as any) || [];
    return rows.map(w => ({ value: w.id, label: w.name, rec: w }));
  }, [listResp]);

  const missingId = !record && !(params.id && Number.isFinite(Number(params.id)));

  return (
    <>
      <style>{`
        /* Remove gray bg and gray text from disabled inputs/selects only in this page */
        .workarea-no-shade .ant-input[disabled],
        .workarea-no-shade .ant-input-affix-wrapper-disabled,
        .workarea-no-shade .ant-select-disabled .ant-select-selector {
          background-color: transparent !important;
          color: inherit !important;
        }
        .workarea-no-shade .ant-select-disabled .ant-select-selection-item,
        .workarea-no-shade .ant-select-disabled .ant-select-arrow {
          color: inherit !important;
        }
      `}</style>
      <div className="workarea-no-shade">
        <Space direction="vertical" style={{ width: '100%' }} size={8}>
          {missingId && (
            <Card size="small" title={<Typography.Text strong>Select a work area to view</Typography.Text>}>
              <Select
                showSearch
                allowClear
                placeholder="Search work area"
                style={{ width: 420 }}
                options={options}
                optionFilterProp="label"
                filterOption={(input, option) => {
                  const label = String(option?.label || '').toLowerCase();
                  const tokens = input.trim().toLowerCase().split(/\s+/).filter(Boolean);
                  return tokens.every(t => label.includes(t));
                }}
                onChange={(val, opt: any) => {
                  const id = Number(val);
                  const rec = opt?.rec as QaqcPipeWorkarea | undefined;
                  if (Number.isFinite(id)) {
                    if (rec) setRecord(rec);
                    navigate(`/qaqc/piping/workareas/view/${id}`, { state: { record: rec } });
                  }
                }}
              />
            </Card>
          )}
          <QaqcPipeWorkareaCreate
            mode="edit"
            initialValues={record}
            onBack={goBack}
            viewOnly
          />
        </Space>
      </div>
    </>
  );
};

export default QaqcPipeWorkareaView;
